module.exports = __webpack_public_path__ + "assets/ISS-e77eb1f72a6c2e97c7a09361cef19d95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/ISS.jpg
// module id = 505
// module chunks = 1